export const LOGS_REQUEST = 'LOGS_REQUEST';
export const LOGS_SUCCESS = 'LOGS_SUCCESS';
export const LOGS_ERROR = 'LOGS_ERROR';
export const LOGS_EMPTY = 'LOGS_EMPTY';
